import type { ArticleReference } from '@src/scenario-editor/providers/fetch.context';

// LF360-2023: a selected article id that fetchArticles() does not offer is explained
// by fetchArticleReferences(). These are the words for each state; the reasons say
// what the subject gets, the same wording the portal uses (lf360-fe#730).
export const REFERENCE_BADGES: Record<string, string> = {
  deleted: 'Deleted',
  switched_off: 'Switched off',
  other_project: 'Another project',
  draft_row: 'Old version',
  group_id: 'Old format',
};

export const REFERENCE_REASONS: Record<string, string> = {
  deleted: "The article was deleted - subjects don't receive it",
  switched_off: "The article is switched off - subjects don't receive it",
  other_project: "An article of another project - subjects don't receive it",
  draft_row: 'An unpublished version is selected - subjects receive the published one',
  group_id: 'Stored in an old format - subjects still receive it',
  available: 'The article cannot be selected here - replace it with one from the list',
};

/** LF360-2015: the picker lists articles A-Z by title. */
export const sortOptionsByLabel = <T extends { label: string }>(options: T[]): T[] =>
  [...options].sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base', numeric: true }));

/** Selected ids the fetched list does not offer, in their selected order. */
export const getUnresolvedIds = (selectedIds: string[], offeredIds: string[]): string[] => {
  const offered = new Set(offeredIds);
  return selectedIds.filter((id) => !offered.has(id));
};

/** The name to show for an unavailable item; never its raw id. */
export const getReferenceLabel = (reference: ArticleReference | undefined, itemName: string): string =>
  reference?.title?.length ? reference.title : `Unknown ${itemName.toLowerCase()}`;
